import { User } from '@backend/domain'
import { UserResponse } from '../types'

export class UserMapper {
	static entityToResponse(user: User): UserResponse {
		return {
			id: user.id,
			firstName: user.firstName,
			lastName: user.lastName,
			fullName: `${user.firstName} ${user.lastName}`,
			email: user.email,
			emailVerified: user.emailVerified,
			preferedLanguage: user.preferedLanguage,
			createdAt: user.createdAt,
		}
	}
}
